import { render, staticRenderFns } from "./home-advantages-v2.vue?vue&type=template&id=56c37570&scoped=true&"
import script from "./home-advantages-v2.vue?vue&type=script&lang=js&"
export * from "./home-advantages-v2.vue?vue&type=script&lang=js&"
import style0 from "./home-advantages-v2.vue?vue&type=style&index=0&id=56c37570&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c37570",
  null
  
)

export default component.exports